import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './promotionAdDetails.css';
import {getRelevantEventsByType} from '../../../../../../../../redux/promotion/promotionActions';
import {useSelector} from 'react-redux';
import EventList from './EventList';
import {PROMOTION_REQUIRMENTS} from './promotionAdConfig';

function PromotionAdDetails({message, onEventListToggle, messageIndex, eventsOpen}) {
    const {t} = useTranslation('promotionMessage');
    const events = useSelector((s: any)=> s.promotion.promotionMessages[messageIndex]?.eventList);
    const getRelevantEventsByTypeXHR = useSelector((s: any)=> s.promotion.getRelevantEventsByTypeXHR);
    const handleEventListClick = async () => {
        if(!eventsOpen) {
            if((!events || events.length === 0) && getRelevantEventsByTypeXHR !== 'LOADING') {
                await getRelevantEventsByType(message.pmid);
            }
        }
        onEventListToggle(message, !eventsOpen);
    };
    const requirements = {...PROMOTION_REQUIRMENTS.default, ...PROMOTION_REQUIRMENTS[message.type]};
    return (
        <>
            <css.row>
                <css.section>
                    {Object.keys(requirements).map((key) => (
                        <css.item key={key}>{t(key)} {requirements[key]}</css.item>
                    ))}
                </css.section>
                <css.item
                    style={{textDecoration: 'underline', cursor: 'pointer'}}
                    onClick={handleEventListClick}
                >
                    {t('eventList')}
                </css.item>
            </css.row>
            {eventsOpen && <EventList events={events || []} />}
        </>
    );
}

export default PromotionAdDetails; 